module.exports = __webpack_public_path__ + "static/img/zhongyejiaotong.3cd1c7c8.png";